module.exports = __webpack_public_path__ + "img/account_note.3fce3918.svg";